export default "/static/avantco_fridge_tiny.png";